import EventEmitter from 'events'
import axios from "../http/axios/index.js"


class ApiService extends EventEmitter {
    
    // Локальный API-сервер
    // url_pre = 'http://localhost/v1/';
    // url_after = '.php';

    // mynex.ru API-сервер
    url_pre = 'https://api.mynex.ru/v1/';
    url_after = '';

    emitNotifyEvent(data) {
        this.emit('notifyEvent', data);
    }

    emitLoadingEvent(show) {
        this.emit('loadingEvent', show);
    }

    items_update(uid = null, series = null, token = null) {
        if (uid == null) {
            localStorage.removeItem('mynex_uid');
        } else {
            localStorage.setItem('mynex_uid', uid);
        }
        if (series == null) {
            localStorage.removeItem('mynex_series');
        } else {
            localStorage.setItem('mynex_series', series);
        }
        if (token == null) {
            localStorage.removeItem('mynex_token');
        } else {
            localStorage.setItem('mynex_token', token);
        }
    }

    api_request(func, params) {

        let uid = localStorage.getItem("mynex_uid");
        let token = localStorage.getItem("mynex_token");
        let series = localStorage.getItem("mynex_series");
        let data = "";
        data += "uid=" + uid;
        data += "&token=" + token;
        data += "&series=" + series;
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                data += "&"+key+"=" + encodeURIComponent(params[key]);
            }
        }
        const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
        };

        let url = this.url_pre + func + this.url_after;
        // url = encodeURI(url);

        return new Promise((resolve, reject) => {
            
            axios.post(url, data, { headers: headers })
            .then((res) => {
                this.emitLoadingEvent(false);
                resolve(res.data);
            })
            .catch(error => {
                this.emitNotifyEvent({
                    title: 'Ошибка соединения',
                    text: error.message === 'Network Error' ? 'Проверьте подключение к Интернету' : error.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                this.emitLoadingEvent(false);
                reject(error);
            })

        });
    }

    api_url_generate(func, params) {
        let ret_val = this.url_pre;
        ret_val += func;
        ret_val += this.url_after;
        ret_val += '?uid=' + localStorage.getItem('mynex_uid');
        ret_val += '&series=' + localStorage.getItem('mynex_series');
        ret_val += '&token=' + localStorage.getItem('mynex_token');
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                ret_val += '&' + key + '=' + params[key];
            }
        }
        return ret_val;
    }

    async auth(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);

        console.log('auth begin');

        try {
            const res = await this.api_request('auth/' + ev, params);
            this.items_update(res.uid, res.series, res.token);
            if (callback) {
                callback(res);
            }
        } catch (e) {
            console.log('auth e', e);

            if (callback) {
                callback(e);
            }
        }
    }

    async authr(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('auth/' + ev, params);
        callback(res.response);
    }

    async setting(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('setting/' + ev, params);
        callback(res.response);
    }

    async adjust(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('adjust/' + ev, params);
        callback(res.response);
    }

    async parameter(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('parameter/' + ev, params);
        callback(res.response);
    }

    async widget(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('widget/' + ev, params);
        callback(res.response);
    }

    async command(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('command/' + ev, params);
        callback(res.response);
    }

    async client(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('client/' + ev, params);
        callback(res.response);
    }

    async notify(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('notify/' + ev, params);
        callback(res.response);
    }
    async object(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('object/' + ev, params);
        callback(res.response);
    }

    async payment(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('payment/' + ev, params);
        callback(res.response);
    }

    async partner(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('partner/' + ev, params);
        callback(res.response);
    }

    async partner_program(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('partner/program/' + ev, params);
        callback(res.response);
    }

    async partner_device(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('partner/device/' + ev, params);
        callback(res.response);
    }

    async device(loader, ev, params = null, callback) {
        this.emitLoadingEvent(loader);
        const res = await this.api_request('device/' + ev, params);
        callback(res.response);
    }

}

export default new ApiService();
